import type {ObjectPath} from "#template/template-node/types"
import type {TemplateNode} from "#template/template-node/template-node"
import {isProceduralTemplateNode} from "#template/role-markers"

export const objectPathStartsWith = (path: ObjectPath, start: ObjectPath) => {
    if (start.length > path.length) return false
    let belowProceduralTemplateNode = false
    for (let i = 0; i < start.length; i++) {
        if (!belowProceduralTemplateNode) {
            if (path[i] !== start[i]) return false
            if (isProceduralTemplateNode(start[i])) belowProceduralTemplateNode = true
        } else {
            if (path[i].instanceId !== start[i].instanceId) return false
        }
    }
    return true
}

export const getTemplateNodeForObjectPath = (objectPath: ObjectPath): TemplateNode => {
    const templateNode = objectPath.at(-1)
    if (!templateNode) throw new Error("Object path is empty")
    return templateNode
}

export const getRootTemplateNodeForObjectPath = (objectPath: ObjectPath): TemplateNode => {
    const templateNode = objectPath.at(0)
    if (!templateNode) throw new Error("Object path is empty")
    return templateNode
}
